import doc               from '@widesk-core/decorators/doc';
import AdminServiceModel from '@/models/AdminServiceModel';
import model             from '@widesk-core/decorators/model';

@doc.urnResource('site_page_status')
@doc.path('/site_page_statuses/{?id}')
@model.cacheDuration()
export default class SitePageStatusModel extends AdminServiceModel {
	private declare _tsFilters: {
		partial: string;
	};

	@doc.string declare name: string;
	@doc.number declare value: number;
	@doc.string declare label: string;
	@doc.string declare reference: Admin_SitePageStatusReference;

	get color() {
		switch (this.reference) {
			case 'PUBLISHED':
				return 'green';
			case 'DRAFT':
				return 'red';
		}
	}
}